import { Modal } from '@/components/Modal/Modal';
import { useState } from 'react';
import styles from './styles.module.css';
import ThinkingBackground from '@/components/thinkingUI/ThinkingBackground';
import { Text, Button, Divider, Icon, IconType } from '@/ui';
import { Trans, useTranslation } from 'react-i18next';
import { Column, Row } from '@/components/SettingsLayout';
import { useGetUser } from '@/hooks';
import line5Svg from '@/assets/icons/Line5.svg';
type Props = Record<string, never>;

function InitialPopUp(_props: Props) {
  const { t } = useTranslation();
  const { currentUser } = useGetUser();
  const [hasRequested, setHasRequested] = useState(
    localStorage.getItem('user_access_request') !== null,
  );
  const [open, setOpen] = useState(true);

  const bookCall = () => {
    window.dataLayer.push({
      event: 'user_access_request',
      feature: 'scale',
      email: currentUser.email,
      firstName: currentUser.firstName,
      lastName: currentUser.lastName,
      ts: Date.now(),
    });
    localStorage.setItem('user_access_request', 'true');
    setHasRequested(true);
  };

  return (
    <Modal
      closeModal={() => {
        setOpen(false);
      }}
      open={open}
      fitContent
      closeOnOverlayClick={false}
    >
      <div className={styles.initialPopUpContainer}>
        <div className={styles.initialPopUpLeftSide}>
          <div className={styles.leftSideContent}>
            <Icon type={IconType.ScaleLogo} width={106} height={46} />
            <Text size='l' weight='medium' color='base-blue'>
              <Trans i18nKey='Initial_pop_up.title' components={[<strong />]} />
            </Text>
            <div className={styles.imageContainer}>
              <iframe
                src='https://www.youtube-nocookie.com/embed/Q0axiSe3fSg?autoplay=1&mute=1&loop=1&playlist=Q0axiSe3fSg&rel=0&modestbranding=1&playsinline=1'
                title={t('Initial_pop_up.video_title')}
                frameBorder='0'
                allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
                allowFullScreen
              />
            </div>
            <Column gapSize='4' className={styles.phoneSection}>
              <Row align='center'>
                <Icon type={IconType.PhoneCall} width={32} height={32} />
                <Text size='m' weight='light-medium' color='base-blue'>
                  <Trans
                    i18nKey='Initial_pop_up.subtitle'
                    components={[<span className={styles.highlightExtension} />]}
                  />
                </Text>
              </Row>
              <Text size='s' weight='light-medium' color='base-blue'>
                {t('Initial_pop_up.subtitle_2')}
              </Text>
            </Column>
          </div>
          <div className={styles.bottomSection}>
            <Divider />
            <div className={styles.buttonContainer}>
              {hasRequested ? (
                <div className={styles.confirmedRow}>
                  <Icon type={IconType.CheckTick} width={32} height={32} />
                  <Text size='m' weight='light-medium'>
                    <Trans
                      i18nKey='Initial_pop_up.meeting_requested'
                      components={[<span className={styles.confirmedText} />]}
                    />
                  </Text>
                </div>
              ) : (
                <Button variant='primary' size='large' onClick={bookCall}>
                  {t('Initial_pop_up.button')}
                </Button>
              )}
            </div>
          </div>
        </div>
        <ThinkingBackground>
          <div className={styles.initialPopUpRightSide}>
            <div
              className={styles.closeButton}
              onClick={() => (window.location.href = import.meta.env.VITE_HUB_URL)}
            >
              <Icon type={IconType.Close} width={18} height={18} />
            </div>
            <div className={styles.featuresList}>
              <div className={styles.featureText}>
                <span className={styles.featureDot}></span>
                <Text size='m' weight='light-medium' color='white'>
                  {t('Initial_pop_up.feature1')}
                </Text>
              </div>
              <img src={line5Svg} alt='initial feature1' className={styles.lineSvg} />
              <div className={styles.featureText}>
                <span className={styles.featureDot}></span>
                <Text size='m' weight='light-medium' color='white'>
                  {t('Initial_pop_up.feature2')}
                </Text>
              </div>
              <img src={line5Svg} alt='initial feature1' className={styles.lineSvg} />
              <div className={styles.featureText}>
                <span className={styles.featureDot}></span>
                <Text size='m' weight='light-medium' color='white'>
                  {t('Initial_pop_up.feature3')}
                </Text>
              </div>
              <img src={line5Svg} alt='initial feature1' className={styles.lineSvg} />
              <div className={styles.featureText}>
                <span className={styles.featureDot}></span>
                <Text size='m' weight='light-medium' color='white'>
                  {t('Initial_pop_up.feature4')}
                </Text>
              </div>
              <img src={line5Svg} alt='initial feature1' className={styles.lineSvg} />
              <div className={styles.featureText}>
                <span className={styles.featureDot}></span>
                <Text size='m' weight='light-medium' color='white'>
                  {t('Initial_pop_up.feature5')}
                </Text>
              </div>
            </div>
          </div>
        </ThinkingBackground>
      </div>
    </Modal>
  );
}

export default InitialPopUp;
